import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
//slices
import { 
  cartSelector, 
  resetDiscountCart, 
  setIsShippingAvailable 
} from 'slices/cart';

const ResetOnRouteChangeCartDiscount = ({children}) => {
  const location = useLocation();
  const dispatch = useDispatch();
  const { discountCart, isShippingAvailable } = useSelector(cartSelector);
  
  useEffect(() => {
    const excludedPaths = ['/carrito', '/envio', '/pago' ];
    if (!excludedPaths.includes(location.pathname) && discountCart?.has_discount) {
      dispatch(resetDiscountCart());
    }
    if (!excludedPaths.includes(location.pathname) && !isShippingAvailable?.availability) {
      dispatch(setIsShippingAvailable({ availability: true, message: '' }));
    }
  }, [location, dispatch, discountCart, isShippingAvailable]);

  return children;
};

export default ResetOnRouteChangeCartDiscount;